/**
 * Format a duration in seconds as a clock string: `m:ss` under an hour,
 * `h:mm:ss` at/above it. Returns null for null / non-finite input.
 *
 * Shared by WatchPlayer (the duration badge) and ShareMenu (the "Start at"
 * clock) so both render identical strings for the same number of seconds.
 * Formatting itself lives in utils/duration.ts.
 */
import { formatDurationClock } from "@/utils/duration";

export function formatDuration(seconds: number | null): string | null {
  if (seconds === null || !Number.isFinite(seconds)) {
    return null;
  }
  return formatDurationClock(Math.max(0, Math.round(seconds)));
}
